import React from 'react';
import { choose } from '../../utils/platform';
import { useInvite } from './useInvite';
import InviteDesktop from './Invite.desktop';
import InviteMobile from './Invite.mobile';

const InviteView = choose(InviteDesktop, InviteMobile);

// Public guest invitation page (no auth, no app shell). Reached at /#/invite.
export default function Invite() {
  const vm = useInvite();
  return <InviteView vm={vm} />;
}
